import * as actions from '../actions/actionTypes';
import { IConfigState, IState } from '../store/state';

const initialConfigState : IConfigState = {
    clientId: 0,
    language: '',
    style: '',
    baseUrl: '',
    s5Alias: '',
    hostedSolutionAlias: '',
    applicationBaseUrl: '',
    playerclassAssets: '',
    isMobile: false,
    oddType: '',
    componentContainer: null,
    pollInactiveChannels: false,
    componentName: '',
    layout: null,
    maintenanceUrl: '',
    host: '',
    focusmatchid: null, 
    skinningsUrl: ''
}

const config = (state:IConfigState = initialConfigState, action: any) : IConfigState => {
    switch (action.type) {
        case actions.CHANGE_ODD_TYPE: 
            return setOddType(state, action.oddType)
        default:
            return state;
    }
};

const setOddType = (state: IConfigState, oddType: string) : IConfigState => ({...state, oddType})

export const getConfig = (state:IState) => state.config;

export const getClientId = (state:IState) => state.config.clientId;

export const getLanguage = (state:IState) => state.config.language;

export const getStyle = (state:IState) => state.config.style;

export const getBaseUrl = (state:IState) => state.config.baseUrl;

export const getS5Alias = (state:IState) => state.config.s5Alias;

export const getHostedSolutionAlias = (state:IState) => state.config.hostedSolutionAlias;

export const getApplicationBaseUrl = (state:IState) => state.config.applicationBaseUrl;

export const getPlayerclassAssetURL = (state:IState) => state.config.playerclassAssets;

export const getMobileStatus = (state:IState) => state.config.isMobile;

export const getOddType = (state:IState) => state.config.oddType;

export const getComponentContainer = (state:IState) => state.config.componentContainer

export const getPollInactiveChannels = (state:IState) => state.config.pollInactiveChannels;

export const getHost = (state:IState) => state.config.host;

export const getFocusMatchId = (state:IState) => state.config.focusmatchid;

export const getSkinningsUrl = (state:IState) => state.config.skinningsUrl;

export default config;
